import { trackPromise } from "react-promise-tracker";
import { initializeApp } from "firebase/app";
import {
    GoogleAuthProvider,
    signInWithEmailAndPassword,
    signInWithPopup,
    getAuth,
    createUserWithEmailAndPassword,
    sendEmailVerification,
    updateProfile,
    signOut,
    sendPasswordResetEmail,
    confirmPasswordReset,
} from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyCq-p5sJ7TTkGh3WIx3rVNpCgSCoZhblB8",
    authDomain: "adcb-andebol-app.firebaseapp.com",
    projectId: "adcb-andebol-app",
    storageBucket: "adcb-andebol-app.appspot.com",
    messagingSenderId: "977955004675",
    appId: "1:977955004675:web:21ef062746fe173d96c936"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

const signInWithGoogle = async (callback) => {
    const provider = new GoogleAuthProvider();
    try {
        const result = await trackPromise(signInWithPopup(auth, provider));
        callback({user: result.user, error: null});
    }
    catch (error) {
        console.log("[Firebase Error - Sign In With Google]", error.code, error.message);
        callback({user: null, error: error});
    }
};

const signInWithEmail = async (email, password, callback) => {
    try {
        const res = await trackPromise(signInWithEmailAndPassword(auth, email, password));
        if (res.user.emailVerified === false) {
            await trackPromise(signOut(auth));
            callback({user: res.user, error: {code: "custom/user-disabled"}});
        }
        else {
            callback({user: res.user, error: null});
        }
    }
    catch (error) {
        console.log("[Firebase Error - Sign In With Email and Password]", error);
        callback({user: null, error: error});
    }
};

const signUp = async (name, email, password, callback) => {
    try {
        const res = await trackPromise(createUserWithEmailAndPassword(auth, email, password));
        if (res.user) {
            await trackPromise(updateProfile(res.user, {displayName: name}));
            const { host, protocol } = window.location;
            const actionCodeSettings = { url: `${protocol}//${host}/login` };
            await trackPromise(sendEmailVerification(res.user, actionCodeSettings));
        }
        callback({user: res.user, error: null});
    }
    catch (error) {
        console.log("[Firebase Error - Sign Up]", error.code, error.message);
        callback({user: null, error: error});
    }
};

const logout = async () => {
    await trackPromise(signOut(auth));
};

const resetPassword = async (email, callback) => {
    const { host, protocol } = window.location;
    try {
        await trackPromise(
            sendPasswordResetEmail(
                auth,
                email,
                { url: `${protocol}//${host}/login` }
            )
        );
        callback({error: null});
    }
    catch (error) {
        console.log("[Firebase Error - Reset Password]", error.code, error.message);
        callback({error: error});
    }
}

const confirmReset = async (code, password, callback) => {
    try {
        await trackPromise(confirmPasswordReset(auth, code, password));
        callback({error: null});
    }
    catch (error) {
        console.log("[Firebase Error - Confirm Reset]", error.code, error.message);
        callback({error: error});
    }
}


export { signInWithGoogle, signInWithEmail, signUp, logout, resetPassword, confirmReset, auth };
